import React from "react";
import { Layout } from "antd";
import Sidebar from "./SideBar";
import { Outlet } from "react-router-dom";

export default function DashboardLayout() {
  return (
    <Layout className="min-h-screen">
      <Sidebar />
      <Layout>
        <Outlet />{" "}
      </Layout>
    </Layout>
  );
}
